import moment from "moment";
export const formatDate = function (value, arg, offsetOptional) {
  if (value) {
    if (arg === undefined) {
      arg = "MMM DD, YYYY [at] hh:mm A";
    }
    const offset = offsetOptional
      ? 0
      : moment().utcOffset(String(value))._offset;
    return moment(String(value)).utcOffset(offset).format(arg);
    // return moment.utc(value).format(arg);
  }
};

export const localFormatDate = function (value, arg, offsetOptional) {
  if (value) {
    if (arg === undefined) {
      arg = "MMM DD, YYYY [at] hh:mm A";
    }

    return moment.utc(value).format(arg);
  }
};

/**
 * upperCaseFirst
 * @description capitalize the first letter of a word
 * @return {String}
 */
export const upperCaseFirst = (str) => {
  return str ? str.toString().replace(/^\w/, (c) => c.toUpperCase()) : "";
};

export const lowerCaseFirst = (str) => {
  return str ? str.toString().replace(/^\w/, (c) => c.toLowerCase()) : "";
};

export const formatDay = function (value, arg, offsetOptional) {
  if (value) {
    if (arg === undefined) {
      arg = "MMM DD, YYYY";
    }
    const offset = offsetOptional
      ? 0
      : moment().utcOffset(String(value))._offset;
    return moment(String(value)).utcOffset(offset).format(arg);
    // return moment.utc(value).format(arg);
  }
};
export const currency = function (value, type) {
  if (typeof value !== 'number') {
    return value
  }
  if (type == 'currency') {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    })
    return formatter.format(value)
  } else if (type == 'currencyCent') {
    if (value === 0) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      })
    } else {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      })
    }
    return formatter.format(value)
  } else if (type == 'digit') {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 0,
    })
    return formatter.format(value)
  }
}

export const numberStatFormat = function (value, symbol='') {
  let number = 0
  if (typeof value !== 'number') {
    return value
  }
  if (value >= 1000000000) {
    number = (value / 1000000000).toFixed(1) + "B";
  } else if (value >= 1000000) {
    number = (value / 1000000).toFixed(1) + "M";
  } else if (value >= 1000) {
    number = (value / 1000).toFixed(1) + "K";
  } else {
    number = value.toString();
  }
  return `${symbol}${number}`
}

/**
 * Removes underscore in a string and capitalizes all the letters in the string
 * @returns String with no underscore in it and letters capitalized
 */
export const underscoreRemover = (value) => {
  if(!value) return value;
 return value
   .replaceAll("_", " ")
   .split(" ")
   .map(int => upperCaseFirst(int))
   .join(" ");
};

export function calculatePercentage(numerator, denominator) {
  if (!numerator || !denominator) return 0;
  return (numerator / denominator) * 100;
}